module.exports = __webpack_public_path__ + "img/insight-light.8877d3bf.svg";